// // Complete The Look - Final Cart Drawer Fix
// (function() {
//   'use strict';

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initCompleteTheLook);
//   } else {
//     initCompleteTheLook();
//   }

//   function initCompleteTheLook() {
//     const completeTheLookItems = document.querySelectorAll('.complete-the-look-item');
    
//     completeTheLookItems.forEach(function(item) {
//       const selects = item.querySelectorAll('.product-option-select');
//       const variantIdInput = item.querySelector('.variant-id-input');
//       const variantsJsonEl = item.querySelector('.product-variants-json');
//       const priceElement = item.querySelector('.complete-the-look-price .price-regular');
//       const comparePriceElement = item.querySelector('.complete-the-look-price .price-compare');
//       const colorDisplay = item.querySelector('.current-color');
//       const addToCartBtn = item.querySelector('.complete-the-look-btn');
//       const form = item.querySelector('.complete-the-look-form');
      
//       if (!variantsJsonEl) return;
      
//       let variantsData;
//       try {
//         variantsData = JSON.parse(variantsJsonEl.textContent);
//       } catch (e) {
//         console.error('Failed to parse variants JSON:', e);
//         return;
//       }
      
//       // Handle variant selection
//       selects.forEach(function(select) {
//         select.addEventListener('change', function() {
//           updateVariant(item, variantsData, variantIdInput, priceElement, comparePriceElement, colorDisplay, addToCartBtn);
//         });
//       });
      
//       // CRITICAL: Handle form submission
//       if (form) {
//         form.addEventListener('submit', function(e) {
//           e.preventDefault();
//           e.stopPropagation();
          
//           const variantId = variantIdInput.value;
//           const quantity = 1;
          
//           if (!variantId || addToCartBtn.disabled) {
//             return false;
//           }
          
//           // Loading state
//           addToCartBtn.classList.add('loading');
//           addToCartBtn.disabled = true;
//           const originalText = addToCartBtn.textContent;
//           addToCartBtn.textContent = 'ADDING...';
          
//           // Add to cart using theme's format
//           const formData = new FormData();
//           formData.append('id', variantId);
//           formData.append('quantity', quantity);
//           formData.append('sections', getSectionsToRender().map(s => s.section).join(','));
//           formData.append('sections_url', window.location.pathname);
          
//           fetch(theme.routes.cart_add_url, {
//             method: 'POST',
//             headers: {
//               'X-Requested-With': 'XMLHttpRequest',
//               'Accept': 'application/javascript'
//             },
//             body: formData
//           })
//           .then(response => response.json())
//           .then(response => {
//             console.log('✓ Product added to cart');
            
//             // Success state
//             addToCartBtn.textContent = 'ADDED!';
//             addToCartBtn.classList.remove('loading');
            
//             setTimeout(() => {
//               addToCartBtn.textContent = originalText;
//               addToCartBtn.disabled = false;
//             }, 2000);
            
//             // Render cart sections (theme's way)
//             renderCartSections(response);
            
//             // Dispatch theme's cart event
//             dispatchCustomEvent('cart:item-added', {
//               product: response.hasOwnProperty('items') ? response.items[0] : response
//             });
            
//             // Open cart drawer (theme's way)
//             setTimeout(() => {
//               openThemeCartDrawer();
//             }, 100);
//           })
//           .catch(error => {
//             console.error('✗ Cart error:', error);
//             addToCartBtn.classList.remove('loading');
//             addToCartBtn.textContent = originalText;
//             addToCartBtn.disabled = false;
//             alert('Failed to add to cart. Please try again.');
//           });
          
//           return false;
//         });
//       }
//     });
//   }

//   // Get sections to render (same as theme)
//   function getSectionsToRender() {
//     return [
//       {
//         id: 'Cart',
//         section: 'main-cart',
//         selector: '.thb-cart-form'
//       },
//       {
//         id: 'Cart-Drawer',
//         section: 'cart-drawer',
//         selector: '.cart-drawer'
//       },
//       {
//         id: 'cart-drawer-toggle',
//         section: 'cart-bubble',
//         selector: '.thb-item-count'
//       }
//     ];
//   }

//   // Render cart sections (theme's way)
//   function renderCartSections(parsedState) {
//     getSectionsToRender().forEach(section => {
//       const element = document.getElementById(section.id);
//       if (!element) return;
      
//       const elementToReplace = element.querySelector(section.selector) || element;
      
//       if (parsedState.sections && parsedState.sections[section.section]) {
//         elementToReplace.innerHTML = getSectionInnerHTML(
//           parsedState.sections[section.section],
//           section.selector
//         );
//       }
//     });
    
//     // Reinitialize CartDrawer if exists
//     if (typeof CartDrawer !== 'undefined') {
//       new CartDrawer();
//     }
//   }

//   // Get section HTML (theme's way)
//   function getSectionInnerHTML(html, selector) {
//     return new DOMParser()
//       .parseFromString(html, 'text/html')
//       .querySelector(selector || '.shopify-section').innerHTML;
//   }

//   // Open cart drawer (EXACTLY like theme does it)
//   function openThemeCartDrawer() {
//     const cartDrawer = document.getElementById('Cart-Drawer');
    
//     if (!cartDrawer) {
//       console.warn('Cart drawer not found');
//       return;
//     }
    
//     // Theme's exact method
//     document.body.classList.add('open-cc');
//     document.body.classList.add('open-cart');
//     cartDrawer.classList.add('active');
//     cartDrawer.focus();
    
//     // Show product recommendations if exists
//     setTimeout(() => {
//       const recommendations = cartDrawer.querySelector('.product-recommendations--full');
//       if (recommendations) {
//         recommendations.classList.add('active');
//       }
//     }, 100);
    
//     // Dispatch theme's event
//     dispatchCustomEvent('cart-drawer:open');
    
//     console.log('✓ Cart drawer opened');
//   }

//   // Dispatch custom event (theme's way)
//   function dispatchCustomEvent(eventName, data) {
//     const detail = data ? { detail: data } : null;
//     const event = new CustomEvent(eventName, detail);
//     document.dispatchEvent(event);
//   }

//   // Update variant
//   function updateVariant(item, variantsData, variantIdInput, priceElement, comparePriceElement, colorDisplay, addToCartBtn) {
//     const colorSelect = item.querySelector('.color-select');
//     const sizeSelect = item.querySelector('.size-select');
    
//     const selectedColor = colorSelect ? colorSelect.value : null;
//     const selectedSize = sizeSelect ? sizeSelect.value : null;
    
//     const colorIndex = variantsData.colorIndex;
//     const sizeIndex = variantsData.sizeIndex;
    
//     const matchingVariant = variantsData.variants.find(function(variant) {
//       let colorMatch = true;
//       let sizeMatch = true;
      
//       if (selectedColor && colorIndex > 0) {
//         colorMatch = variant['option' + colorIndex] === selectedColor;
//       }
      
//       if (selectedSize && sizeIndex > 0) {
//         sizeMatch = variant['option' + sizeIndex] === selectedSize;
//       }
      
//       return colorMatch && sizeMatch;
//     });
    
//     if (matchingVariant) {
//       if (variantIdInput) {
//         variantIdInput.value = matchingVariant.id;
//       }
      
//       if (priceElement && matchingVariant.price) {
//         priceElement.textContent = formatMoney(matchingVariant.price);
//       }
      
//       if (comparePriceElement) {
//         if (matchingVariant.compare_at_price > matchingVariant.price) {
//           comparePriceElement.textContent = formatMoney(matchingVariant.compare_at_price);
//           comparePriceElement.style.display = '';
//         } else {
//           comparePriceElement.style.display = 'none';
//         }
//       }
      
//       if (colorDisplay && selectedColor) {
//         colorDisplay.textContent = selectedColor;
//       }
      
//       if (colorSelect && sizeSelect) {
//         updateSizeAvailability(sizeSelect, variantsData, selectedColor, colorIndex, sizeIndex);
//       }
      
//       if (addToCartBtn) {
//         if (matchingVariant.available) {
//           addToCartBtn.disabled = false;
//           addToCartBtn.textContent = 'ADD TO CART';
//           addToCartBtn.classList.remove('out-of-stock');
//         } else {
//           addToCartBtn.disabled = true;
//           addToCartBtn.textContent = 'OUT OF STOCK';
//           addToCartBtn.classList.add('out-of-stock');
//         }
//       }
//     }
//   }

//   function updateSizeAvailability(sizeSelect, variantsData, selectedColor, colorIndex, sizeIndex) {
//     const options = sizeSelect.querySelectorAll('option');
    
//     options.forEach(function(option) {
//       const sizeValue = option.value;
      
//       const availableVariant = variantsData.variants.find(function(variant) {
//         const colorMatch = colorIndex > 0 ? variant['option' + colorIndex] === selectedColor : true;
//         const sizeMatch = sizeIndex > 0 ? variant['option' + sizeIndex] === sizeValue : true;
//         return colorMatch && sizeMatch && variant.available;
//       });
      
//       if (availableVariant) {
//         option.disabled = false;
//         option.textContent = sizeValue;
//       } else {
//         option.disabled = true;
//         option.textContent = sizeValue + ' (Out of Stock)';
//       }
//     });
    
//     const currentSelectedOption = sizeSelect.querySelector('option:checked');
//     if (currentSelectedOption && currentSelectedOption.disabled) {
//       const firstAvailableOption = sizeSelect.querySelector('option:not([disabled])');
//       if (firstAvailableOption) {
//         sizeSelect.value = firstAvailableOption.value;
//         sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     }
//   }

//   function formatMoney(cents) {
//     if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
//       return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || '${{amount}}');
//     }
//     const dollars = (cents / 100).toFixed(2);
//     return '$' + dollars;
//   }
// })();

// Complete The Look - Final Cart Drawer Fix
(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompleteTheLook);
  } else {
    initCompleteTheLook();
  }

  function initCompleteTheLook() {
    const completeTheLookItems = document.querySelectorAll('.complete-the-look-item');
    
    completeTheLookItems.forEach(function(item) {
      const selects = item.querySelectorAll('.product-option-select');
      const variantIdInput = item.querySelector('.variant-id-input');
      const variantsJsonEl = item.querySelector('.product-variants-json');
      const priceElement = item.querySelector('.complete-the-look-price .price-regular');
      const comparePriceElement = item.querySelector('.complete-the-look-price .price-compare');
      const colorDisplay = item.querySelector('.current-color');
      const addToCartBtn = item.querySelector('.complete-the-look-btn');
      const form = item.querySelector('.complete-the-look-form');
      
      if (!variantsJsonEl) return;
      
      let variantsData;
      try {
        variantsData = JSON.parse(variantsJsonEl.textContent);
      } catch (e) {
        console.error('Failed to parse variants JSON:', e);
        return;
      }
      
      // Handle variant selection
      selects.forEach(function(select) {
        select.addEventListener('change', function() {
          updateVariant(item, variantsData, variantIdInput, priceElement, comparePriceElement, colorDisplay, addToCartBtn);
        });
      });
      
      // CRITICAL: Handle form submission
      if (form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const variantId = variantIdInput.value;
          const quantity = 1;
          
          if (!variantId || addToCartBtn.disabled) {
            return false;
          }
          
          // Loading state
          addToCartBtn.classList.add('loading');
          addToCartBtn.disabled = true;
          const originalText = addToCartBtn.textContent;
          addToCartBtn.textContent = 'ADDING...';
          
          // Add to cart using theme's format
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', quantity);
          formData.append('sections', getSectionsToRender().map(s => s.section).join(','));
          formData.append('sections_url', window.location.pathname);
          
          fetch(theme.routes.cart_add_url, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            },
            body: formData
          })
          .then(response => response.json())
          .then(response => {
            console.log('✓ Product added to cart');
            
            // Success state
            addToCartBtn.textContent = 'ADDED!';
            addToCartBtn.classList.remove('loading');
            
            setTimeout(() => {
              addToCartBtn.textContent = originalText;
              addToCartBtn.disabled = false;
            }, 2000);
            
            // Render cart sections (theme's way)
            renderCartSections(response);
            
            // Dispatch theme's cart event
            dispatchCustomEvent('cart:item-added', {
              product: response.hasOwnProperty('items') ? response.items[0] : response
            });
            
            // Open cart drawer (theme's way)
            setTimeout(() => {
              openThemeCartDrawer();
            }, 100);
          })
          .catch(error => {
            console.error('✗ Cart error:', error);
            addToCartBtn.classList.remove('loading');
            addToCartBtn.textContent = originalText;
            addToCartBtn.disabled = false;
            alert('Failed to add to cart. Please try again.');
          });
          
          return false;
        });
      }
    });
  }

  // Get sections to render (same as theme)
  function getSectionsToRender() {
    return [
      {
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }
    ];
  }

  // Render cart sections (theme's way)
  function renderCartSections(parsedState) {
    getSectionsToRender().forEach(section => {
      const element = document.getElementById(section.id);
      if (!element) return;
      
      const elementToReplace = element.querySelector(section.selector) || element;
      
      if (parsedState.sections && parsedState.sections[section.section]) {
        elementToReplace.innerHTML = getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });
    
    // Reinitialize CartDrawer if exists
    if (typeof CartDrawer !== 'undefined') {
      new CartDrawer();
    }
  }

  // Get section HTML (theme's way)
  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector || '.shopify-section').innerHTML;
  }

  // Open cart drawer (EXACTLY like theme does it)
  function openThemeCartDrawer() {
    const cartDrawer = document.getElementById('Cart-Drawer');
    
    if (!cartDrawer) {
      console.warn('Cart drawer not found');
      return;
    }
    
    // Theme's exact method
    document.body.classList.add('open-cc');
    document.body.classList.add('open-cart');
    cartDrawer.classList.add('active');
    cartDrawer.focus();
    
    // Show product recommendations if exists
    setTimeout(() => {
      const recommendations = cartDrawer.querySelector('.product-recommendations--full');
      if (recommendations) {
        recommendations.classList.add('active');
      }
    }, 100);
    
    // Dispatch theme's event
    dispatchCustomEvent('cart-drawer:open');
    
    console.log('✓ Cart drawer opened');
  }

  // Dispatch custom event (theme's way)
  function dispatchCustomEvent(eventName, data) {
    const detail = data ? { detail: data } : null;
    const event = new CustomEvent(eventName, detail);
    document.dispatchEvent(event);
  }

  // Update variant
  function updateVariant(item, variantsData, variantIdInput, priceElement, comparePriceElement, colorDisplay, addToCartBtn) {
    const colorSelect = item.querySelector('.color-select');
    const sizeSelect = item.querySelector('.size-select');
    
    const selectedColor = colorSelect ? colorSelect.value : null;
    const selectedSize = sizeSelect ? sizeSelect.value : null;
    
    const colorIndex = variantsData.colorIndex;
    const sizeIndex = variantsData.sizeIndex;
    
    const matchingVariant = variantsData.variants.find(function(variant) {
      let colorMatch = true;
      let sizeMatch = true;
      
      if (selectedColor && colorIndex > 0) {
        colorMatch = variant['option' + colorIndex] === selectedColor;
      }
      
      if (selectedSize && sizeIndex > 0) {
        sizeMatch = variant['option' + sizeIndex] === selectedSize;
      }
      
      return colorMatch && sizeMatch;
    });
    
    if (matchingVariant) {
      if (variantIdInput) {
        variantIdInput.value = matchingVariant.id;
      }
      
      if (priceElement && matchingVariant.price) {
        priceElement.textContent = formatMoney(matchingVariant.price);
      }
      
      if (comparePriceElement) {
        if (matchingVariant.compare_at_price > matchingVariant.price) {
          comparePriceElement.textContent = formatMoney(matchingVariant.compare_at_price);
          comparePriceElement.style.display = '';
        } else {
          comparePriceElement.style.display = 'none';
        }
      }
      
      if (colorDisplay && selectedColor) {
        colorDisplay.textContent = selectedColor;
      }
      
      if (colorSelect && sizeSelect) {
        updateSizeAvailability(sizeSelect, variantsData, selectedColor, colorIndex, sizeIndex);
      }
      
      if (addToCartBtn) {
        if (matchingVariant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'ADD TO CART';
          addToCartBtn.classList.remove('out-of-stock');
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'OUT OF STOCK';
          addToCartBtn.classList.add('out-of-stock');
        }
      }
    }
  }

  function updateSizeAvailability(sizeSelect, variantsData, selectedColor, colorIndex, sizeIndex) {
    const options = sizeSelect.querySelectorAll('option');
    
    options.forEach(function(option) {
      const sizeValue = option.value;
      
      const availableVariant = variantsData.variants.find(function(variant) {
        const colorMatch = colorIndex > 0 ? variant['option' + colorIndex] === selectedColor : true;
        const sizeMatch = sizeIndex > 0 ? variant['option' + sizeIndex] === sizeValue : true;
        return colorMatch && sizeMatch && variant.available;
      });
      
      if (availableVariant) {
        option.disabled = false;
        option.textContent = sizeValue;
      } else {
        option.disabled = true;
        option.textContent = sizeValue + ' (Out of Stock)';
      }
    });
    
    const currentSelectedOption = sizeSelect.querySelector('option:checked');
    if (currentSelectedOption && currentSelectedOption.disabled) {
      const firstAvailableOption = sizeSelect.querySelector('option:not([disabled])');
      if (firstAvailableOption) {
        sizeSelect.value = firstAvailableOption.value;
        sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function formatMoney(cents) {
    // Use theme's money format
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      // Try multiple sources for money format
      let format = null;
      
      // Method 1: Check theme settings
      if (window.theme && window.theme.settings && window.theme.settings.money_format) {
        format = window.theme.settings.money_format;
      }
      
      // Method 2: Check theme.moneyFormat
      if (!format && window.theme && window.theme.moneyFormat) {
        format = window.theme.moneyFormat;
      }
      
      // Method 3: Check global theme variable
      if (!format && typeof theme !== 'undefined' && theme.settings && theme.settings.money_format) {
        format = theme.settings.money_format;
      }
      
      // FORCE: Always use no decimals format for Euro
      if (format && format.includes('€')) {
        format = '€{{amount_no_decimals}}';
      }
      
      // Default fallback
      if (!format) {
        format = '€{{amount_no_decimals}}';
      }
      
      return Shopify.formatMoney(cents, format);
    }
    
    // Simple fallback - always no decimals
    return '€' + Math.round(cents / 100);
  }
})();